const hy = {
  feedbackLabel: `Ձեր կարծիքը շատ կարևոր է նախագծի զարգացման համար`,
  feedbackError: `Դաշտը պարտադիր է`,
  emailLabel: `Ձեր էլ․ փոստը (ըստ ցանկության)`,
  emailPlaceholder: `էլ. հասցե`,
  emailError: `Սխալ էլ. հասցե`,
  info1: `Դուք կարող եք ուղիղ կապ հաստատել հեղինակի հետ գրելով իր LinkedIn կամ Facebook էջերին, `,
  info2: `կամ նամակով`,
  cancelButtonLabel: `Չեղարկել`,
  submitButtonLabel: `Հաստատել`,
};

export default hy;
